import React from 'react';

const AuthContext = React.createContext({ isAuthenticated: false, jwt: null, infos: null });

export default AuthContext;
